import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { basicSavePerson } from "../api/basicSavePerson";
import { getUUID } from "../api/getUUID";
import { ineVerificate } from "../api/ineVerificate";
import Modal from "react-bootstrap/Modal";
import foodbrand from "../assets/foodbrand@2x.png";
import Header from "../Header/Header";

function ValidacionFace() {

    const navigate = useNavigate();
    const [show, setShow] = useState(true);
    const [showStatus, setShowStatus] = useState("400");
    const [showMessage, setShowMessage] = useState("Autenticación incorrecta");
    const [loading, setLoading] = useState(false);

    const handleCloseError = async () => {
        setShow(false);
        navigate("/FaceLoginPassaporte", {
            state: {
                rutaContinue: "/PantallaBase27",
                typeCredential: "lic",
            },
        });
    };

    return (
        <>
            <div className="initBack_P2 animate__animated animate__fadeIn">
                <Header
                    imgBack={true}
                    rutaBack="/PantallaBase14"
                    title="Identificación Personal"
                    name="steepThree"
                />
                <div className="containerRender">
                    {loading ? (
                        <div className="spinner"></div>
                    ) : (
                        <div className="animate__animated animate__fadeIn">

                            <div className="containerInfo_P2">
                                <div className="containerIdent_P2" />
                            </div>

                            <div className="footer">
                                <div className="imageContainer_P2">
                                    <img src={foodbrand} className="imgFooter_P2" />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal show={show} onHide={handleCloseError} animation={false} centered backdrop="static">
                <Modal.Body className="backGroudModal">
                    <div className="msjTitleModalDiv">Error {showStatus}</div>
                    <div className="msjErrorModal">{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button_P2" onClick={handleCloseError}>
                        <span className="txtButton_P2">Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ValidacionFace;
